import { fonts } from 'src/sheets'

export const getThemeColor = (type = 'default') => {
  switch (type) {
    case 'secondary':
      return theme.secondary.main

    case 'success':
      return theme.success.main

    case 'default':
    case 'primary':
    default:
      return theme.primary.main
  }
}

export const theme = {
  name: 'default',
  primary: {
    main: '#0D71F0',
  },
  secondary: {
    main: '#FF9D2E',
  },
  success: {
    main: '#6BB70B',
    feedback: {
      400: '#87CE2C',
    },
  },
  neutral: {
    main: '#B0B3C0',
  },

  error: '#EB4343',
  colors: {
    white: '#FFFFFF',
    grey: {
      100: '#363843',
      200: '#4D5163',
      300: '#646981',
      400: '#B0B3C0',
      500: '#C6C8D1',
      550: '#e2e8f0',
      800: '#e4e1e9',
      850: '#E3E3E8',
      900: '#f4f4f7',
    },
    blue: {
      100: '#66A9FF',
      200: '#308dfe',
      500: '#3399ff',
      600: '#1a73e8',
      700: '#0C64D3',
    },
    red: {
      100: '#DE1818',
    },
    orange: '#FFA82E',
    pink: {
      100: '#E5009126',
      700: '#FF397F',
      900: '#E50091',
    },
    purple: {
      800: '#5c33ff',
    },
    black: {
      200: '#202125',
    },
  },
  fonts: fonts,
}
